<template>
  <div class="row service_builder_block">
    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
        <div class="block-header">
            {{blocks.content.header}}
        </div>
        <div class="block-data">
            {{blocks.content.description}}
        </div>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
        <div class="link-data" v-html="blocks.imagedata.text">
        </div>
        <div class="img-block">
            <img class="img-width" :src="`${getImageUrl(blocks.imagedata.image)}`" alt="img">
        </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['blocks', 'sasToken'],
  data() {
    return {};
  },
  methods: {
    getImageUrl(filePath) {
      return `${process.env.VUE_APP_AZURE_BLOB_URL}/${filePath}?${this.sasToken}`;
    },
  },
};
</script>
<style scoped>
.service_builder_block {
  margin: 0px;
  padding: 40px 40px 15px;
  background: rgba(103, 177, 226, 0.1);
}
.block-header {
    padding-bottom: 20px;
    font-size: 24px;
    color: #67b1e2;
}
.block-data {
    font-size: 18px;
}
.linnk-data {
    font-size: 14px;
}
.img-block {
    float: right;
    margin-top: 20px;
}
.img-width
{
    width: 180px;
}
@media screen and (max-width:767px) {
  .service_builder_block{
    padding: 20px 20px 15px;
  }

}
</style>
